<template>
  <!-- 商品分组 -->
  <div class="addGoodsGroup">
    <!-- 面包屑导航 -->
    <page-bar
      @back="goBack"
      @refresh="handleRefresh"
      :title="$route.meta.title"
    >
      <template slot="controls" v-if="isEdit">
        <el-link
          icon="el-icon-question"
          type="primary"
          :href="baseUrl + '/UploadFile/Template/商品导入模板.xls'"
          target="_blank"
          >下载模板</el-link
        >
        <el-dropdown style="margin-left: 10px" @command="dropdownCommand">
          <el-button type="primary">
            批量上传商品<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="1">按商品内码上传</el-dropdown-item>
            <el-dropdown-item :command="2">按商品编号上传</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <upload
          style="margin-left: 10px; display: none"
          ref="upload"
          @fileChange="uploadSortImg"
          text="批量上传"
        ></upload>
        <el-button
          style="margin-left: 10px"
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="getGoodsList('')"
          >新增商品</el-button
        >
        <el-button
          type="danger"
          icon="el-icon-delete"
          :disabled="selectedList.length == 0"
          @click="handleDel('')"
          >批量删除
        </el-button>
      </template>
    </page-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-input
          v-model="searchForm.name"
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入编号/名称/厂家"
          @keyup.enter.native="getTableData(1)"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      :row-style="{ color: '#303133' }"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
    >
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="goodsId"
        align="center"
        show-overflow-tooltip
        label="商品编号"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        align="center"
        show-overflow-tooltip
        label="商品名称"
      >
      </el-table-column>
      <el-table-column
        prop="factory"
        label="生产厂家"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="spec"
        label="规格"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="unit"
        label="单位"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="time"
        label="加入时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="操作" align="center" v-if="isEdit">
        <template slot-scope="scope">
          <el-button
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="handleDel(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>

    <!-- 数据选择 -->
    <tableDialog
      v-if="dialogVisible"
      title="商品选择"
      :isMoreSel="true"
      :searchValue="searchGoods.name"
      :tableData="tableList"
      :tableHead="tableHead"
      :currPage.sync="currPageGoods"
      :allPage="allPageGoods"
      @search="getGoodsList"
      @moreSel="selDataOk"
      @rowClick="rowClick"
      @hanCurrChange="hanChangeGoods"
      @close="dialogVisible = false"
    ></tableDialog>
  </div>
</template>

<script>
//表单验证
// import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "addGoodsGroup",
  data() {
    return {
      /**表格数据 */
      // {
      //   id: "商品编号",
      //   goodsId: "商品ID",
      //   name:"商品名称",
      //   factory:"生产厂家",
      //   spec:"规格",
      //   unit:"单位",
      //   time:"加入时间",
      // }
      isEdit: true,
      tableData: [],
      searchForm: {
        name: "",
      },
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      selectedList: [],
      /**新增drawer */
      addDrawer: false,
      /**新增分组表单 */
      addForm: {
        id: "", // 分组ID
        type: "", // 分组类型
        name: "", // 分组名称
        sort: "", // 分组排序
      },
      addFormRule: {},
      // 数据选择
      dialogVisible: false,
      searchGoods: {
        name: "",
      },
      tableList: [],
      tableHead: {},
      currPageGoods: 1,
      allPageGoods: 0,

      /**上传表格 */
      uploadData: {
        groupId: "",
      },
    };
  },
  mounted() {
    if (this.$route.query.prams) {
      let prams = JSON.parse(decodeURIComponent(this.$route.query.prams));
      for (const key in this.addForm) {
        this.addForm[key] = prams[key];
      }
      this.uploadData.groupId = prams.id;
      this.isEdit = prams.isEdit;
      this.getTableData();
    }
  },
  methods: {
    updata() {
      this.getTableData();
    },
    goBack() {
      this.$router.go(-1);
      this.$destroy();
    },
    /**获取表格 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "GetPromGoodsDetail",
        groupId: this.addForm.id,
        strWhere: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "Proc_PromGoodsGroup"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url:
          "prom/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          this.tableData = [];
          this.allPage = res.recordCount;
          if (res.flag == 0) {
            this.tableData = res.data.map((item) => ({
              id: item.Id,
              goodsId: item.ArticleId,
              name: item.sub_title,
              factory: item.drug_factory,
              spec: item.drug_spec,
              unit: item.package_unit,
              time: item.AddTime,
            }));
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },

    // 获取弹出框表格数据
    getGoodsList(val, isRep) {
      this.searchGoods.name = isRep ? val : this.searchGoods.name;
      let data = {
        type: "GoodsList",
        groupId: this.addForm.id,
        PageIndex: this.currPageGoods,
        PageSize: 10,
        strWhere: this.searchGoods.name,
        QueryType: "FZSP",
      };
      let proc = "Proc_Admin_SearchInfo"; //存储过程名
      let type = "ReturnDataSet";
      this.$requestSys({
        method: "post",
        url:
          "ashx/MainReturnJson.ashx?json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&type=" +
          type +
          "&proc=" +
          proc,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.tableList = res.content;
            this.tableHead = res.fdname;
            this.allPageGoods = res.recordCount;
            this.dialogVisible = true;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**当前页改变 */
    hanChangeGoods(val) {
      this.currPageGoods = val;
      this.getGoodsList();
    },
    // 选择单条数据
    rowClick(row) {
      this.selDataOk([row]);
    },
    // 选择数据完成，多选
    selDataOk(selectedList) {
      if (selectedList.length == 0) {
        this.$message({
          message: "请选择数据",
          type: "warning",
        });
        return;
      }
      let goodsId = selectedList.map((item) => item.keyid).join(",");
      this.submit(goodsId);
    },

    /**点击删除商品 */
    handleDel(id) {
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          id = id || this.selectedList.map((item) => item.id).join(",");
          let data = {
            type: "DltPromGoodsList",
            GroupId: this.addForm.id,
            keyId: id,
          };
          let proc = "Proc_PromGoodsGroup"; //存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            url:
              "prom/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            method: "post",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {});
    },
    /**提交新增分类 */
    submit(goodsId) {
      let data = {
        groupId: this.addForm.id,
        goodsList: goodsId,
      };

      this.$request({
        method: "post",
        url: "/Management/GoodsAdmin/SaveGoodsGroupDt",
        data,
      })
        .then((res) => {
          if (res.success) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.getTableData();
            this.dialogVisible = false;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    dropdownCommand(val) {
      console.log(val, "ces");
      if (val == 1) {
        this.uploadData.goodscood = "商品内码";
      } else {
        this.uploadData.goodscood = "商品编号";
      }
      this.$refs.upload.handleClick();
    },
    /**上传excel */
    uploadSortImg(file) {
      if (file.length) {
        const formData = new FormData();
        formData.append("file", file[0]);
        this.$uploadRequest({
          method: "post",
          url:
            "/Management/GoodsAdmin/GoodsGroupToExcel?groupId=" +
            this.uploadData.groupId +
            "&keyType=" +
            this.uploadData.goodscood,
          data: formData,
        })
          .then((res) => {
            let type = "success";
            if (res.success) {
              type = "success";
              this.searchForm.name = "";
              this.getTableData(1);
            } else {
              type = "error";
            }

            this.$message({
              message: res.message,
              type,
            });
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  },
};
</script>

<style scoped>
.addGoodsGroup {
  width: 100%;
  height: 100%;
}
</style>
